import React from 'react';
import PageWrapper from '@/components/layout/PageWrapper';
import { META } from '@/config/constants';
import { Hero2Column } from '@/components/sections/Hero/Hero2Column';
import { CTA } from '@/components/sections/CTA/CTA';
import { careersData, benefitsData, jobPositions } from '@/config/careersData';
import LifeAtCobalt from '@/components/sections/LifeAtCobalt';
import OpenPositions from '@/components/sections/OpenPositions';
import { Benefits } from '@/components/sections/Careers';
import ContentCallout from '@/components/sections/ConnectorOptions/ContentCallout';

const Careers: React.FC = () => {
  return (
    <PageWrapper
      title={META.CAREERS.TITLE}
      description={META.CAREERS.DESCRIPTION}
      keywords={["Cobalt careers", "SaaS integration jobs", "embedded iPaaS careers", "tech jobs"]}
    >
      <div className="text-center md:text-left">
        <Hero2Column
          title={careersData.hero.title}
          subtext={careersData.hero.description}
          image={careersData.hero.backgroundImage}
          tag={careersData.hero.tag.text}
          tagHref={careersData.hero.tag.href || '#'}
          buttonText={careersData.hero.cta.primary.text}
          buttonHref={careersData.hero.cta.primary.href}
        />
      </div>

        {/* Benefits Section */}
      <Benefits
        title={benefitsData.title}
        subtitle={benefitsData.subtitle}
        benefits={benefitsData.benefits}
      />

      {/* Life at Cobalt Section */}
      <LifeAtCobalt
        title={careersData.lifeAtCobalt.title}
        description={careersData.lifeAtCobalt.description}
        images={careersData.lifeAtCobalt.images}
      />

        {/* Open Positions */}
      <OpenPositions
        title={careersData.openPositions.title}
        description={careersData.openPositions.description}
        positions={jobPositions}
      />

      {/* Content Callout */}
      <ContentCallout
        title={careersData.stayConnected.title}
        card={{
          title: careersData.stayConnected.description,
          description: `Email your CV to <a href="mailto:${careersData.stayConnected.email.address}" class="text-primary-600 hover:underline">${careersData.stayConnected.email.text}</a>`
        }}
        cta={{
          text: careersData.stayConnected.linkedin.text,
          href: careersData.stayConnected.linkedin.href
        }}
      />

       {/* <Bento4
        title={careersData.bentoProcess.title}
        description={careersData.bentoProcess.description}
        features={careersData.bentoProcess.features}
          /> */}

      {/* <TestimonialCarousel
        testimonials={teamTestimonials}
        backgroundColor="bg-white"
        textColor="text-gray-900"
        impactSection={careersData.testimonials}
      /> */}

      <CTA
        title={careersData.cta.title}
        description={careersData.cta.description}
        cta={careersData.cta.cta}
      />
    </PageWrapper>
  );
};

export default Careers;